import { useState, useEffect, useCallback } from 'react';

const getIndicatorColor = (diffMs) => {
    const minutes = diffMs / 60000;
    if (minutes < 15) return '#22c55e';
    if (minutes <= 20) return '#f97316';
    return '#ef4444';
};

const formatElapsed = (ms) => {
    if (ms <= 0) return '0s';
    const totalSecs = Math.floor(ms / 1000);
    const hours = Math.floor(totalSecs / 3600);
    const minutes = Math.floor((totalSecs % 3600) / 60);
    const seconds = totalSecs % 60;

    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
};

const ElapsedTime = ({ since, frozenAt, style, prefix = '' }) => {
    const [elapsed, setElapsed] = useState('');
    const [diffMs, setDiffMs] = useState(0);

    const calculate = useCallback(() => {
        if (!since) return { text: '', ms: 0 };

        const endPoint = frozenAt ? new Date(frozenAt).getTime() : Date.now();
        const ms = endPoint - new Date(since).getTime();
        return { text: formatElapsed(ms), ms: Math.max(ms, 0) };
    }, [since, frozenAt]);

    useEffect(() => {
        if (!since) return;

        const update = () => {
            const result = calculate();
            setElapsed(result.text);
            setDiffMs(result.ms);
        };

        update();
        if (frozenAt) return;
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [since, frozenAt, calculate]);

    if (!since) return <span style={style}>-</span>;

    return (
        <span title={frozenAt ? "Check-in time paused" : "Time elapsed since passenger checked in"} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, color: getIndicatorColor(diffMs), cursor: 'default', ...style }}>
            <span style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: getIndicatorColor(diffMs),
                flexShrink: 0,
            }} />
            {prefix}{elapsed}
        </span>
    );
};

export { getIndicatorColor };
export default ElapsedTime;
